<mat-dialog-content style="height: 100%; max-height: 90%">
    <div class="center-content armabox medium-border-arma-color" style="display: flex; flex-direction: row; height: 90%">
        <form class="example-form form searchPanel armarow content formIE">
            <mat-form-field class="example-full-width">
                <mat-label>{{"Code" | translate}}</mat-label>
                    <input  matInput
                        (keydown)="onKeyCodeDown($event)"
                        (keyup)="onFilterChange()"
                        [(ngModel)]="HTML_INPUT_FILTER"
                        (ngModelChange)="HTML_INPUT_FILTER = $event.toUpperCase()"
                        [ngModelOptions]="{standalone: true}"
                        placeholder="exemple: 10B" />
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ "Nombre de plis" | translate }} </mat-label>
                <select matNativeControl
                        (change)="onFilterChange()"
                        [(ngModel)]= "HTML_INPUT_PLIURE"
                        [ngModelOptions]="{standalone: true}">
                    <option *ngFor="let input of mInput" [value]="input.value">{{input.viewValue | translate}}</option>
                </select>
            </mat-form-field>
        </form>
      <div class="armabox left-medium-border-arma-color ieonly" style="width: inherit">
        <div #scroll class="armarow content tableIE" style="width: 100%; overflow-y: scroll;">
          <table
            mat-table
            #table
            [dataSource]="HTML_TABLE_DATASOURCE">
            <!-- Colonne des Shapes -->
            <ng-container matColumnDef="SHAPE">
              <th style="text-align: center; width: 100%;" mat-header-cell *matHeaderCellDef>
                {{ "Formes" | translate }}
              </th>
              <td mat-cell *matCellDef="let element">
                <button id="ArmaShapeFavoriteBtn-{{element.CodeForme}}"
                        style="position: relative"
                        *ngIf="IsFavorite(element) != null"
                        mat-icon-button
                        class="ArmaShape-Favorite {{IsFavorite(element) ? 'checked' : 'unchecked'}}"
                        (click)="ToggleFavorite($event, element)">
                  <mat-icon>star</mat-icon>
                </button>
                {{element.CodeForme}}
                <div style="text-align: center;">
                  <arma-shape
                    [shape] ="element"
                    width = "300"
                    height = "150"
                    [Entermeasure] = "false"
                    id="example-forme-trace-{{element.CodeForme}}">
                  </arma-shape>
                </div>
              </td>
            </ng-container>

            <!-- Colonne pour les propriétés de la forme -->
            <ng-container matColumnDef="Action">
              <th style="text-align: center; width: 100%;" mat-header-cell *matHeaderCellDef>
                {{ "Properties" | translate }}
              </th>
              <td mat-cell style="padding: 24px;" *matCellDef="let element">
                <div id="propertyTab">
                  <mat-checkbox
                    (keydown)="onKeyCodeDown($event)"
                    (keyup)="onFilterChange()"
                    [(ngModel)]="getShapeFavoriteProperties(element).PanelVisible"
                    [ngModelOptions]="{standalone: true}"
                    (change)="OnPropertiesChange(element)"
                    [disabled]="IsFavorite(element) || (element.WebSelectable != 2)">
                    {{ "Visible in shapes list" | translate }}
                  </mat-checkbox>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row class="armaor-background-color tr-header" *matHeaderRowDef="HTML_TABLE_HEADER_COL; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: HTML_TABLE_HEADER_COL"></tr>
          </table>
        </div>
        <div class="armarow footer">
          <mat-paginator [pageSizeOptions]="[5, 10, 20]" [pageSize] = "10" [hidePageSize]="true" showFirstLastButtons (page)="onPageChange()"></mat-paginator>
        </div>
      </div>
    </div>
</mat-dialog-content>
<div mat-dialog-actions>
    <button mat-raised-button (click)="onDialogBtnClick('OK')">OK</button>
</div>
